import { render, staticRenderFns } from "./facilitatorItem.vue?vue&type=template&id=39739ac6&scoped=true&"
import script from "./facilitatorItem.vue?vue&type=script&lang=ts&"
export * from "./facilitatorItem.vue?vue&type=script&lang=ts&"
import style0 from "./facilitatorItem.vue?vue&type=style&index=0&id=39739ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39739ac6",
  null
  
)

export default component.exports